import SmoothScroll from 'smooth-scroll/dist/smooth-scroll'

up.compiler('.smooth-scroll', function() {
  const smoothScroll = new SmoothScroll('a[data-scroll]')

  return () => {
    smoothScroll.destroy()
  }
})